"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.push.js");
const multipleMode = ['tags', 'multiple', 'checkbox'];
var _default = exports.default = {
  name: 'YsSelect',
  components: {
    VNodes: {
      functional: true,
      render: (h, ctx) => ctx.props.vnodes
    }
  },
  props: {
    options: {
      type: Array,
      default: () => []
    },
    placeholder: {
      type: String,
      default: '请选择'
    },
    value: {
      type: [Array, String, Number],
      default: undefined
    },
    mode: {
      type: String,
      default: 'single'
    },
    disabled: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Object,
      default: () => ({
        value: 'value',
        label: 'label'
      })
    },
    showActions: {
      type: Boolean,
      default: false
    },
    showArrow: {
      type: Boolean,
      default: true
    },
    showSearch: {
      type: Boolean,
      default: true
    },
    allowClear: {
      type: Boolean,
      default: true
    },
    dropdownStyle: {
      type: Object,
      default: () => ({})
    },
    dropdownClassName: {
      type: String
    },
    getPopupContainer: {
      type: Function,
      default: () => document.body
    },
    filterByValue: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      keyword: undefined
    };
  },
  computed: {
    isMultiple() {
      return multipleMode.includes(this.mode);
    },
    modelValue: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      }
    }
  },
  methods: {
    handleChange(value) {
      let options;
      if (value !== undefined && value !== null) {
        if (this.isMultiple && value.length > 0) {
          options = this.options.filter(item => value.includes(item[this.fields.value]));
        } else {
          options = this.options.find(item => value === item[this.fields.value]);
        }
      }
      this.$emit('change', value, options);
    },
    handleSearch(keyword) {
      this.keyword = keyword;
    },
    handleFocus() {
      this.$emit('focus');
    },
    handleBlur() {
      this.$emit('blur');
    },
    handleDropdownVisibleChange(open) {
      if (!open) {
        this.keyword = undefined;
      }
    },
    filterOption(input, option) {
      const isTextMatch = option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      if (this.filterByValue) {
        return isTextMatch || option.key.toLowerCase().indexOf(input.toLowerCase()) >= 0;
      }
      return isTextMatch;
    },
    handleSelectAllClick() {
      const newValue = [];
      this.options.forEach(item => {
        if (!this.keyword) {
          newValue.push(item[this.fields.value]);
        } else if (item[this.fields.label].toLowerCase().indexOf(this.keyword.toLowerCase()) >= 0) {
          newValue.push(item[this.fields.value]);
        }
      });
      this.modelValue = newValue;
      this.handleChange(newValue);
    },
    handleReverseClick() {
      let options = [];
      if (!this.keyword) {
        options = this.options;
      } else {
        options = this.options.filter(item => item[this.fields.label].toLowerCase().indexOf(this.keyword.toLowerCase()) >= 0);
      }
      const newValue = JSON.parse(JSON.stringify(this.modelValue ?? []));
      options.forEach(item => {
        const index = newValue.indexOf(item[this.fields.value]);
        if (index === -1) {
          newValue.push(item[this.fields.value]);
        } else {
          newValue.splice(index, 1);
        }
      });
      this.modelValue = newValue;
      this.handleChange(newValue);
    },
    handleResetClick() {
      this.modelValue = this.isMultiple ? [] : undefined;
      this.handleChange(this.isMultiple ? [] : undefined);
    }
  }
};